import { lazy } from "react";

export { DOCUMENT_REGISTER_TYPE_PATH } from "./document-register-type-path";
export const DocumentRegisterTypePage = lazy(
  () => import("./document-register-type-page"),
);
